import * as i18next from "i18next"
import { AsyncState, Updater, navigate } from 'widgets-for-react'
import { Debounced } from '../../../../custom_components/debounce/debounce.state'
import { search, getCategoryCounts } from '../../../drupal/api/api.mod'
import { PaginatedItem, SearchResultItem } from '../../../drupal/types_and_parser/extra_types.mod'
import { ParsedNodeUpdate } from '../../../drupal/types_and_parser/types.ext.gen'

export type SearchOverviewState = {
  overview_page: number
  current_query: Debounced<string>
  get_suggestions: AsyncState<Immutable.List<string>>
  get_searches: AsyncState<PaginatedItem<SearchResultItem>>
  get_updates: AsyncState<PaginatedItem<ParsedNodeUpdate>>
  pageTypeSelection: SearchSelectState
  get_category_counts: AsyncState<{ [key: string]: number }>
  sortBy: string
}

type SearchSelectOption = { value: string, label: string }

export type SearchSelectState = {
  options: SearchSelectOption[]
  selection: string
  placeholder: string
}

export const mkSearchSelectState = (values: SearchSelectOption[], selection?: string, placeholder?: string): SearchSelectState => ({
  options: values,
  selection: selection,
  placeholder: placeholder || i18next.t("Common:Select")
})

export const searchOverviewFilterOptions = ['page', 'expertise', 'update', 'project'];

export const searchOverviewUpdaters = {
  setPage:
    (
      page: number,
      query: string,
      lang: string,
      pageName: string,
      pageTypeSelection: SearchSelectState
    ): Updater<SearchOverviewState> =>
    (s) => {
      navigate(
        `/${lang}/${pageName}/${encodeURIComponent(query)}/${page}${
          pageTypeSelection.selection ? `?type=${pageTypeSelection.selection}` : ''
        }`
      )
      return {
        ...s,
        overview_page: page,
        get_searches: search(query, pageTypeSelection.selection || '', page, 10, lang, s.sortBy || 'relevance')
      }
    },
  setQuery:
    (query: string): Updater<SearchOverviewState> =>
    (s) => ({
      ...s,
      current_query: s.current_query.value != query ? Debounced.dirty(query) : Debounced.clean(query)
    }),
  setContentTypeFilter:
    (
      pageTypeSelection: SearchSelectState,
      query: string,
      lang: string,
      pageName: string
    ): Updater<SearchOverviewState> =>
    (s) => {
      let new_selection =
        pageTypeSelection.selection
          ? pageTypeSelection.selection
          : undefined
      if (s.current_query && s.current_query != undefined && s.current_query.value != '') {
        navigate(
          `/${lang}/${pageName}/${encodeURIComponent(query)}/0${
            pageTypeSelection.selection ? `?type=${pageTypeSelection.selection}` : ''
          }`
        )
      }
      return {
        ...s,
        pageTypeSelection: {
          ...pageTypeSelection,
          selection: new_selection ? new_selection : pageTypeSelection.selection
        },
        get_searches: search(query, new_selection || '', 0, 10, lang, s.sortBy || 'relevance'),
        get_category_counts: getCategoryCounts(lang, query)
      }
    },
  setSortBy:
    (sortBy: string, query: string, lang: string, pageTypeSelection: SearchSelectState): Updater<SearchOverviewState> =>
    (s) => ({
      ...s,
      sortBy,
      get_searches: search(query, pageTypeSelection.selection || '', 0, 10, lang, sortBy)
    })
}
